import React, { useState } from "react";
import {
  EditorState,
  Modifier,
  SelectionState,
} from "draft-js";

const ImageBlock = ({ block, contentState, blockProps }) => {
  const { editorState, onEditorStateChange, readOnly } = blockProps;

  const [hovered, setHovered] = useState(false);

  const entity = contentState.getEntity(block.getEntityAt(0));
  const { src, alt } = entity.getData();

  // const alignment = block.getData().get("alignment") || "center";
  const alignment = entity.getData().alignment || "center";

  // const updateAlignment = (value) => {
  //   const content = editorState.getCurrentContent();
  //   const blockKey = block.getKey();
  //   const blockSelection = SelectionState.createEmpty(blockKey);

  //   const newContent = Modifier.setBlockData(
  //     content,
  //     blockSelection,
  //     { alignment: value }
  //   );

  //   onEditorStateChange(
  //     EditorState.push(editorState, newContent, "change-block-data")
  //   );
  // };

  const updateAlignment = (value) => {
    const content = editorState.getCurrentContent();
    const entityKey = block.getEntityAt(0);

    const newContent = content.mergeEntityData(entityKey, {
      alignment: value,
    });

    onEditorStateChange(
      EditorState.push(editorState, newContent, "apply-entity")
    );
  };


  const deleteImage = () => {
    const content = editorState.getCurrentContent();
    const blockKey = block.getKey();
    const blockMap = content.getBlockMap();

    const blocksBefore = blockMap
      .toSeq()
      .takeUntil((v) => v.getKey() === blockKey);
    const blocksAfter = blockMap
      .toSeq()
      .skipUntil((v) => v.getKey() === blockKey)
      .rest();

    const newBlockMap = blockMap.delete(blockKey);
    const nextBlock = blocksAfter.first() || blocksBefore.last();

    const newSelection = nextBlock
      ? SelectionState.createEmpty(nextBlock.getKey())
      : editorState.getSelection();

    const newContent = content.merge({
      blockMap: newBlockMap,
      selectionAfter: newSelection,
    });

    const newEditorState = EditorState.push(
      editorState,
      newContent,
      "remove-range"
    );

    onEditorStateChange(
      EditorState.forceSelection(newEditorState, newSelection)
    );
  };

  const wrapperStyle = {
    textAlign: alignment,
    position: "relative",
    display: "block",
  };

  const controlsStyle = {
    position: "absolute",
    top: 6,
    left: "50%",
    transform: "translateX(-50%)",
    display: hovered && !readOnly ? "flex" : "none",
    background: "#fff",
    border: "1px solid #ccc",
    padding: 4,
    borderRadius: 4,
    zIndex: 10,
  };

  const buttonStyle = (active) => ({
    padding: "4px 6px",
    margin: "0 2px",
    border: "1px solid #ccc",
    background: active ? "#e0e0e0" : "#fff",
    cursor: "pointer",
  });

  return (
    <div
      style={wrapperStyle}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      <div style={controlsStyle}>
        <button
          type="button"
          onClick={() => updateAlignment("left")}
          style={buttonStyle(alignment === "left")}
        >
          L
        </button>
        <button
          type="button"
          onClick={() => updateAlignment("center")}
          style={buttonStyle(alignment === "center")}
        >
          C
        </button>
        <button
          type="button"
          onClick={() => updateAlignment("right")}
          style={buttonStyle(alignment === "right")}
        >
          R
        </button>
        <button
          type="button"
          onClick={deleteImage}
          style={{
            ...buttonStyle(false),
            marginLeft: 6,
            color: "#e53935",
          }}
        >
          ✕
        </button>
      </div>

      <img src={src} alt={alt || ""} style={{ maxWidth: "100%" }} />
    </div>
  );
};

export default ImageBlock;
